import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Edges } from './GridSizes';
import MediaQueries from './MediaQueries';

const getEdgeValue = viewport => `-${Edges[viewport]}px`;

const Bleed = styled.div(
  {
    position: 'relative',
    minHeight: '1px',
  },
  ({ left, right }) => ({
    marginRight: right && getEdgeValue('sm'),
    marginLeft: left && getEdgeValue('sm'),
    [MediaQueries.md]: {
      marginRight: right && getEdgeValue('md'),
      marginLeft: left && getEdgeValue('md'),
    },
    [MediaQueries.lg]: {
      marginRight: right && getEdgeValue('lg'),
      marginLeft: left && getEdgeValue('lg'),
    },
    [MediaQueries.xl]: {
      marginRight: right && getEdgeValue('xl'),
      marginLeft: left && getEdgeValue('xl'),
    },
  }),
);

Bleed.defaultProps = {
  left: false,
  right: false,
};

Bleed.propTypes = {
  left: PropTypes.bool,
  right: PropTypes.bool,
};

export default Bleed;
